/**
 * useReportUser Hook
 * Mutation hook for submitting user reports
 */

import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { toast } from "sonner"
import { createReport } from "@/services/report.service"

export function useReportUser() {
  return useMutation({
    mutationFn: createReport,
    onError: (error: unknown) => {
      let message = "Failed to submit report"
      if (axios.isAxiosError(error)) {
        message = error.response?.data?.message || error.message
      } else if (error instanceof Error) {
        message = error.message
      }
      toast.error(message)
    },
  })
}
